// extracted by mini-css-extract-plugin
export var bold = "_s9-0";